import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export const useFocusFilter = setFocus => {
  const ref = useRef<HTMLInputElement>();
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
  const [readOnly] = useState(matchesSm);

  useEffect(() => {
    setFocus(() => {
      setTimeout(() => {
        ref?.current?.focus();
        setOpen(true);
      }, 200);
    });

    return () => {
      setFocus(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ref,
    open,
    setOpen,
    readOnly,
  };
};
